import { defineMessages } from '../define';

/** Annotation editing on the sheet viewer: tools, symbols, connectors, selection, layers, sharing. */
export const annotate = defineMessages(
  {
    // Edit toggle (song top bar)
    'annotate.write': 'Skrifa',
    'annotate.done': 'Lokið',
    'annotate.write_hint': 'Skrifa og teikna á nóturnar',
    'annotate.done_hint': 'Hætta að skrifa',

    // Toolbar
    'annotate.toolbar_label': 'Skriftarverkfæri',
    'annotate.options_label': 'Stillingar verkfæris',
    'annotate.tool_pen': 'Penni',
    'annotate.tool_highlighter': 'Yfirstrikun',
    'annotate.tool_text': 'Texti',
    'annotate.tool_stamp': 'Tákn',
    'annotate.tool_connector': 'Tengill',
    'annotate.tool_eraser': 'Strokleður',
    'annotate.tool_select': 'Velja',
    'annotate.undo': 'Afturkalla',
    'annotate.redo': 'Endurgera',
    'annotate.layers': 'Lög',
    'annotate.move_toolbar': 'Færa verkfærastikuna',
    'annotate.move_toolbar_hint': 'Dragðu hana að brún skjásins: lárétt efst eða neðst, lóðrétt til vinstri eða hægri. Örvalyklar færa hana líka.',
    'annotate.pages_label': 'Síður',
    'annotate.prev_page': 'Fyrri síða',
    'annotate.next_page': 'Næsta síða',

    // Tool options
    'annotate.colors': 'Litir',
    'annotate.color_black': 'Svartur',
    'annotate.color_blue': 'Blár',
    'annotate.color_red': 'Rauður',
    'annotate.color_green': 'Grænn',
    'annotate.color_orange': 'Appelsínugulur',
    'annotate.color_yellow': 'Gulur',
    'annotate.color_lightgreen': 'Ljósgrænn',
    'annotate.color_pink': 'Bleikur',
    'annotate.color_lightblue': 'Ljósblár',
    'annotate.color_white': 'Hvítur (hylur)',
    'annotate.width': 'Breidd',
    'annotate.width_thin': 'Mjótt',
    'annotate.width_medium': 'Miðlungs',
    'annotate.width_thick': 'Breitt',
    'annotate.size': 'Stærð',
    'annotate.choose_symbol': 'Velja tákn',
    'annotate.change_symbol': 'Skipta um tákn',
    'annotate.hint_pen': 'Haltu inni á eigin striki til að færa það',
    'annotate.hint_highlighter': 'Dragðu yfir línuna. Haltu inni á eigin striki til að færa það.',
    'annotate.hint_text': 'Ýttu þar sem textinn á að koma, eða á texta til að færa hann',
    'annotate.hint_stamp': 'Ýttu á nóturnar til að setja táknið, eða á tákn til að færa það',
    'annotate.hint_connector': 'Ýttu þar sem tengillinn á að vera',
    'annotate.hint_eraser': 'Dragðu yfir það sem á að eyða',
    'annotate.hint_select': 'Ýttu á teikningu til að velja hana. Dragðu hana til að færa og hornið til að breyta stærðinni.',

    // Save state
    'annotate.sync_saved': 'Allt vistað',
    'annotate.sync_offline': 'Án nets – vistast síðar',
    'annotate.sync_pending': { one: '{count} óvistað', other: '{count} óvistað' },
    'annotate.sync_saving': 'Vista…',
    'annotate.unsaved_locally': 'Ekki tókst að vista teikningarnar á tækinu. Tengstu neti áður en þú lokar appinu svo þær glatist ekki.',
    'annotate.sync_error': 'Ekki vistað – reyna aftur',
    'annotate.sync_tap': 'Vista núna',
    'annotate.loading': 'Hleð teikningum…',
    'annotate.load_error': 'Ekki tókst að hlaða teikningunum.',
    'annotate.pen_detected': 'Apple Pencil fannst. Nú teiknar aðeins penninn og fingurinn flettir. Þessu má breyta í Stillingum.',
    'annotate.not_yours': 'Þetta tilheyrir sameiginlegu lagi og verður ekki breytt hér.',
    'annotate.add_rejected': 'Ekki var hægt að bæta þessu við. Lagið gæti verið fullt – prófaðu að bæta við nýju lagi.',

    // Selection
    'annotate.sel_actions': 'Valin teikning',
    'annotate.sel_edit': 'Breyta',
    'annotate.sel_color': 'Litur',
    'annotate.sel_duplicate': 'Afrita',
    'annotate.sel_delete': 'Eyða',
    'annotate.sel_close': 'Hætta að velja',
    'annotate.sel_resize': 'Dragðu til að breyta stærðinni',
    'annotate.sel_move': 'Dragðu til að færa',
    'annotate.sel_smaller': 'Minnka',
    'annotate.sel_larger': 'Stækka',

    // Text
    'annotate.text_label': 'Texti á nóturnar',
    'annotate.text_placeholder': 'Skrifaðu hér…',

    // Symbols
    'annotate.palette_title': 'Tákn',
    'annotate.palette_recent': 'Nýlega notuð',
    'annotate.palette_preview': 'Valið tákn',
    'annotate.group_accidentals': 'Formerki',
    'annotate.group_digits': 'Tölustafir',
    'annotate.group_dynamics': 'Styrkleiki',
    'annotate.group_articulations': 'Áherslur',
    'annotate.group_technique': 'Fermata og strok',
    'annotate.group_notes': 'Nótur',
    'annotate.group_rests': 'Þagnir',
    'annotate.group_ornaments': 'Skraut og áttundir',
    'annotate.group_navigation': 'Segno og coda',
    'annotate.group_other': 'Annað',

    // Connectors
    'annotate.conn_find_target': 'Flettu á staðinn þar sem á að halda áfram og ýttu þar',
    'annotate.conn_find_new_target': 'Flettu á nýja áfangastaðinn og ýttu þar',
    'annotate.conn_pages': 'Síður',
    'annotate.conn_page': 'Síða {page}',
    'annotate.conn_label_title': 'Merking tengils',
    'annotate.conn_label_hint': 'Valfrjálst: stutt merking sem birtist við tengilinn.',
    'annotate.conn_label_suggestions': 'Tillögur',
    'annotate.conn_label_input': 'Merking',
    'annotate.conn_label_placeholder': 't.d. Coda eða Vers 2',
    'annotate.conn_label_forward': 'Áfram',
    'annotate.conn_label_verse': 'Vers',
    'annotate.conn_no_label': 'Án merkingar',
    'annotate.conn_saved': 'Tengill vistaður',
    'annotate.conn_target_changed': 'Áfangastað breytt',
    'annotate.conn_target_marker': 'Áfangastaður',
    'annotate.conn_retarget': 'Breyta áfangastað',
    'annotate.conn_test': 'Prófa',

    // Layers
    'annotate.layers_sync': 'Vistun',
    'annotate.layers_mine': 'Mín lög',
    'annotate.layers_mine_empty': 'Þú hefur ekki teiknað á þessar nótur enn. Fyrsta teikningin fer í „Mitt lag“.',
    'annotate.layers_shared': 'Sameiginleg lög',
    'annotate.layers_shared_empty': 'Enginn hefur deilt lagi á þessum nótum með þér.',
    'annotate.layer_active': 'Virkt lag – nýjar teikningar fara hingað',
    'annotate.layer_active_short': 'Virkt',
    'annotate.layer_make_active': 'Teikna í „{name}“',
    'annotate.layer_show': 'Sýna „{name}“',
    'annotate.layer_hide': 'Fela „{name}“',
    'annotate.layer_rename': 'Endurnefna',
    'annotate.layer_share': 'Deila',
    'annotate.layer_delete': 'Eyða',
    'annotate.layer_delete_title': 'Eyða laginu „{name}“?',
    'annotate.layer_delete_body': 'Allar teikningar í laginu hverfa, líka hjá þeim sem þú hefur deilt því með.',
    'annotate.layer_add': 'Bæta við lagi',
    'annotate.layer_name': 'Heiti lags',
    'annotate.layer_default_name': 'Nýtt lag',
    'annotate.layer_private': 'Aðeins þú',
    'annotate.layer_shared_with': 'Deilt með: {list}',
    'annotate.layer_owner_left': '{name} (hætt/ur)',
    'annotate.layer_from_leaders': 'frá stjórnendum',
    'annotate.layer_stale_badge': 'Gert á eldri útgáfu',
    'annotate.layer_copy': 'Afrita í mitt lag',
    'annotate.layer_copy_name': '{name} – afrit',
    'annotate.layer_copied': 'Afritað í nýtt lag: {name}',
    'annotate.someone': 'Félagi',
    'annotate.stale': 'Sumt var teiknað á eldri útgáfu nótnanna',
    'annotate.stale_hint': 'Nóturnar hafa verið uppfærðar síðan, svo teikningar gætu hafa hliðrast.',
    'annotate.stale_review': 'Skoða og staðfesta',
    'annotate.stale_hide_all': 'Fela lög af eldri útgáfu',
    'annotate.stale_hide_hint': {
      one: '{count} lag var teiknað á eldri útgáfu nótnanna.',
      other: '{count} lög voru teiknuð á eldri útgáfu nótnanna.',
    },
    'annotate.stale_hidden_toast': 'Lög af eldri útgáfu eru falin. Þú getur sýnt þau aftur undir „Lög“ í „Skrifa“.',
    'annotate.stale_show_again': 'Sýna aftur',
    'annotate.stale_review_title': 'Passa teikningarnar enn?',
    'annotate.stale_review_body1':
      'Nóturnar hafa verið uppfærðar síðan þú teiknaðir á þær. Flettu í gegnum nýju útgáfuna og athugaðu hvort merkingarnar þínar passi enn – að yfirstrikanir, tákn, texti og tenglar séu á réttum stað.',
    'annotate.stale_review_body2':
      'Lagaðu það sem hefur hliðrast. Þegar allt passar ýtirðu á „Staðfesta“. Þá hverfur viðvörunin hjá öllum sem sjá lagið.',
    'annotate.stale_review_layers': 'Þín lög á eldri útgáfu',
    'annotate.stale_review_hidden': 'falið',
    'annotate.stale_review_none': 'Þú átt ekkert lag á eldri útgáfu þessara nótna.',
    'annotate.stale_review_look': 'Skoða fyrst',
    'annotate.stale_review_confirm': 'Staðfesta',
    'annotate.stale_review_confirm_n': { one: 'Staðfesta {count} lag', other: 'Staðfesta {count} lög' },
    'annotate.stale_confirmed': {
      one: 'Staðfest. Viðvörunin hverfur hjá öllum sem sjá lagið.',
      other: '{count} lög staðfest. Viðvörunin hverfur hjá öllum sem sjá þau.',
    },
    'annotate.stale_confirmed_offline': 'Staðfest. Það vistast þegar tækið kemst aftur á netið.',
    'annotate.stale_look_hint': 'Flettu í gegnum nóturnar. Þú staðfestir svo í viðvöruninni eða undir „Lög“.',

    // Sharing
    'annotate.share_title': 'Deila „{name}“',
    'annotate.share_readonly': 'Þau sem þú deilir með geta skoðað lagið en ekki breytt því.',
    'annotate.share_groups': 'Raddir',
    'annotate.share_people': 'Einstaklingar',
    'annotate.share_search': 'Leita að nafni',
    'annotate.share_cant_see': 'Sér ekki þessar nótur',
    'annotate.share_sections_cant_see': 'Sjá ekki þessar nótur: {list}',
    'annotate.share_covered': 'Fær þegar aðgang með röddinni',
    'annotate.share_no_people': 'Enginn fannst',
    'annotate.share_none': 'Ekki deilt – aðeins þú sérð lagið.',
    'annotate.share_offline': 'Deiling krefst nettengingar.',
    'annotate.share_failed': 'Ekki tókst að deila laginu. Reyndu aftur.',
    'annotate.share_invalid': 'Sumir viðtakendur sjá ekki þessar nótur. Breyttu valinu og reyndu aftur.',
    'annotate.share_saved': 'Deilingu breytt',

    // Coach marks
    'annotate.coach_step': 'Skref {n} af {total}',
    'annotate.coach1_title': 'Penni eða fingur',
    'annotate.coach1_body':
      'Með Apple Pencil teiknar penninn og fingurinn flettir. Án penna teiknar einn fingur, en tveir fingur fletta og stækka. Þessu má breyta í Stillingum.',
    'annotate.coach2_title': 'Þín eigin lög',
    'annotate.coach2_body':
      'Það sem þú teiknar fer í þitt eigið lag sem aðeins þú sérð. Undir „Lög“ geturðu bætt við lögum, falið þau og deilt þeim með röddinni þinni eða kórnum.',
    'annotate.coach3_title': 'Tenglar',
    'annotate.coach3_body':
      'Veldu „Tengill“ og ýttu þar sem stökkið á að byrja. Flettu svo þangað sem halda á áfram og ýttu þar. Þegar þú ýtir á tengilinn hoppa nóturnar beint á réttan stað.',
    'annotate.coach_next': 'Áfram',
    'annotate.coach_skip': 'Sleppa',
    'annotate.coach_start': 'Byrja að skrifa',
  },
  {
    'annotate.write': 'Write',
    'annotate.done': 'Done',
    'annotate.write_hint': 'Write and draw on the sheet',
    'annotate.done_hint': 'Stop writing',

    'annotate.toolbar_label': 'Annotation tools',
    'annotate.options_label': 'Tool settings',
    'annotate.tool_pen': 'Pen',
    'annotate.tool_highlighter': 'Highlight',
    'annotate.tool_text': 'Text',
    'annotate.tool_stamp': 'Symbols',
    'annotate.tool_connector': 'Link',
    'annotate.tool_eraser': 'Eraser',
    'annotate.tool_select': 'Select',
    'annotate.undo': 'Undo',
    'annotate.redo': 'Redo',
    'annotate.layers': 'Layers',
    'annotate.move_toolbar': 'Move the toolbar',
    'annotate.move_toolbar_hint': 'Drag it to an edge of the screen: lying along the top or bottom, standing at the left or right. Arrow keys move it too.',
    'annotate.pages_label': 'Pages',
    'annotate.prev_page': 'Previous page',
    'annotate.next_page': 'Next page',

    'annotate.colors': 'Colours',
    'annotate.color_black': 'Black',
    'annotate.color_blue': 'Blue',
    'annotate.color_red': 'Red',
    'annotate.color_green': 'Green',
    'annotate.color_orange': 'Orange',
    'annotate.color_yellow': 'Yellow',
    'annotate.color_lightgreen': 'Light green',
    'annotate.color_pink': 'Pink',
    'annotate.color_lightblue': 'Light blue',
    'annotate.color_white': 'White (covers)',
    'annotate.width': 'Width',
    'annotate.width_thin': 'Thin',
    'annotate.width_medium': 'Medium',
    'annotate.width_thick': 'Thick',
    'annotate.size': 'Size',
    'annotate.choose_symbol': 'Choose symbol',
    'annotate.change_symbol': 'Change symbol',
    'annotate.hint_pen': 'Press and hold your own mark to move it',
    'annotate.hint_highlighter': 'Drag along the line. Press and hold your own mark to move it.',
    'annotate.hint_text': 'Tap where the text goes, or tap a text to move it',
    'annotate.hint_stamp': 'Tap the sheet to place the symbol, or tap one to move it',
    'annotate.hint_connector': 'Tap where the link should be',
    'annotate.hint_eraser': 'Drag over what you want to erase',
    'annotate.hint_select': 'Tap a drawing to select it. Drag it to move it, or drag the corner to resize it.',

    'annotate.sync_saved': 'All saved',
    'annotate.sync_offline': 'Offline – will save later',
    'annotate.sync_pending': { one: '{count} unsaved', other: '{count} unsaved' },
    'annotate.sync_saving': 'Saving…',
    'annotate.unsaved_locally': 'Your drawings could not be saved on this device. Connect to the internet before closing the app so they are not lost.',
    'annotate.sync_error': 'Not saved – try again',
    'annotate.sync_tap': 'Save now',
    'annotate.loading': 'Loading drawings…',
    'annotate.load_error': 'Could not load the drawings.',
    'annotate.pen_detected': 'Apple Pencil detected. Now only the pencil draws and your finger scrolls. You can change this in Settings.',
    'annotate.not_yours': "This belongs to a shared layer and can't be changed here.",
    'annotate.add_rejected': "This couldn't be added. The layer may be full – try adding a new layer.",

    'annotate.sel_actions': 'Selected drawing',
    'annotate.sel_edit': 'Edit',
    'annotate.sel_color': 'Colour',
    'annotate.sel_duplicate': 'Duplicate',
    'annotate.sel_delete': 'Delete',
    'annotate.sel_close': 'Deselect',
    'annotate.sel_resize': 'Drag to resize',
    'annotate.sel_move': 'Drag to move',
    'annotate.sel_smaller': 'Smaller',
    'annotate.sel_larger': 'Larger',

    'annotate.text_label': 'Text on the sheet',
    'annotate.text_placeholder': 'Type here…',

    'annotate.palette_title': 'Symbols',
    'annotate.palette_recent': 'Recently used',
    'annotate.palette_preview': 'Selected symbol',
    'annotate.group_accidentals': 'Accidentals',
    'annotate.group_digits': 'Numbers',
    'annotate.group_dynamics': 'Dynamics',
    'annotate.group_articulations': 'Articulations',
    'annotate.group_technique': 'Fermata & bowings',
    'annotate.group_notes': 'Notes',
    'annotate.group_rests': 'Rests',
    'annotate.group_ornaments': 'Ornaments & octaves',
    'annotate.group_navigation': 'Segno & coda',
    'annotate.group_other': 'Other',

    'annotate.conn_find_target': 'Scroll to where the music continues and tap there',
    'annotate.conn_find_new_target': 'Scroll to the new target and tap there',
    'annotate.conn_pages': 'Pages',
    'annotate.conn_page': 'Page {page}',
    'annotate.conn_label_title': 'Link label',
    'annotate.conn_label_hint': 'Optional: a short label shown next to the link.',
    'annotate.conn_label_suggestions': 'Suggestions',
    'annotate.conn_label_input': 'Label',
    'annotate.conn_label_placeholder': 'e.g. Coda or Verse 2',
    'annotate.conn_label_forward': 'Continue',
    'annotate.conn_label_verse': 'Verse',
    'annotate.conn_no_label': 'No label',
    'annotate.conn_saved': 'Link saved',
    'annotate.conn_target_changed': 'Target changed',
    'annotate.conn_target_marker': 'Target',
    'annotate.conn_retarget': 'Change target',
    'annotate.conn_test': 'Try it',

    'annotate.layers_sync': 'Saving',
    'annotate.layers_mine': 'My layers',
    'annotate.layers_mine_empty': 'You have not drawn on this sheet yet. Your first drawing goes into “My layer”.',
    'annotate.layers_shared': 'Shared layers',
    'annotate.layers_shared_empty': 'Nobody has shared a layer on this sheet with you.',
    'annotate.layer_active': 'Active layer – new drawings go here',
    'annotate.layer_active_short': 'Active',
    'annotate.layer_make_active': 'Draw in “{name}”',
    'annotate.layer_show': 'Show “{name}”',
    'annotate.layer_hide': 'Hide “{name}”',
    'annotate.layer_rename': 'Rename',
    'annotate.layer_share': 'Share',
    'annotate.layer_delete': 'Delete',
    'annotate.layer_delete_title': 'Delete the layer “{name}”?',
    'annotate.layer_delete_body': 'All drawings in the layer disappear, also for the people you shared it with.',
    'annotate.layer_add': 'Add layer',
    'annotate.layer_name': 'Layer name',
    'annotate.layer_default_name': 'New layer',
    'annotate.layer_private': 'Only you',
    'annotate.layer_shared_with': 'Shared with: {list}',
    'annotate.layer_owner_left': '{name} (left)',
    'annotate.layer_from_leaders': 'from the choir leaders',
    'annotate.layer_stale_badge': 'Made on an older version',
    'annotate.layer_copy': 'Copy to my layers',
    'annotate.layer_copy_name': '{name} – copy',
    'annotate.layer_copied': 'Copied to a new layer: {name}',
    'annotate.someone': 'Member',
    'annotate.stale': 'Some drawings were made on an older version of this sheet',
    'annotate.stale_hint': 'The sheet has been updated since, so drawings may be slightly out of place.',
    'annotate.stale_review': 'Review and confirm',
    'annotate.stale_hide_all': 'Hide layers from an older version',
    'annotate.stale_hide_hint': {
      one: '{count} layer was drawn on an older version of the sheet.',
      other: '{count} layers were drawn on an older version of the sheet.',
    },
    'annotate.stale_hidden_toast': 'Layers from an older version are hidden. You can show them again under “Layers” in “Write”.',
    'annotate.stale_show_again': 'Show again',
    'annotate.stale_review_title': 'Do your drawings still fit?',
    'annotate.stale_review_body1':
      'The sheet has been updated since you drew on it. Look through the new version and check that your marks still fit – that highlights, symbols, text and jump links are in the right place.',
    'annotate.stale_review_body2':
      'Fix anything that has moved. When everything fits, tap “Confirm”. The warning then disappears for everyone who sees the layer.',
    'annotate.stale_review_layers': 'Your layers on an older version',
    'annotate.stale_review_hidden': 'hidden',
    'annotate.stale_review_none': 'You have no layers on an older version of this sheet.',
    'annotate.stale_review_look': 'Look first',
    'annotate.stale_review_confirm': 'Confirm',
    'annotate.stale_review_confirm_n': { one: 'Confirm {count} layer', other: 'Confirm {count} layers' },
    'annotate.stale_confirmed': {
      one: 'Confirmed. The warning disappears for everyone who sees the layer.',
      other: '{count} layers confirmed. The warning disappears for everyone who sees them.',
    },
    'annotate.stale_confirmed_offline': 'Confirmed. It will be saved when the device is back online.',
    'annotate.stale_look_hint': 'Look through the sheet. Then confirm in the warning or under “Layers”.',

    'annotate.share_title': 'Share “{name}”',
    'annotate.share_readonly': 'People you share with can view the layer but not change it.',
    'annotate.share_groups': 'Sections',
    'annotate.share_people': 'People',
    'annotate.share_search': 'Search by name',
    'annotate.share_cant_see': "Can't see this sheet",
    'annotate.share_sections_cant_see': "Can't see this sheet: {list}",
    'annotate.share_covered': 'Already included through their section',
    'annotate.share_no_people': 'Nobody found',
    'annotate.share_none': 'Not shared – only you can see this layer.',
    'annotate.share_offline': 'Sharing needs an internet connection.',
    'annotate.share_failed': 'Could not share the layer. Please try again.',
    'annotate.share_invalid': "Some recipients can't see this sheet. Change the selection and try again.",
    'annotate.share_saved': 'Sharing updated',

    'annotate.coach_step': 'Step {n} of {total}',
    'annotate.coach1_title': 'Pencil or finger',
    'annotate.coach1_body':
      'With an Apple Pencil the pencil draws and your finger scrolls. Without a pencil one finger draws, while two fingers scroll and zoom. You can change this in Settings.',
    'annotate.coach2_title': 'Your own layers',
    'annotate.coach2_body':
      'What you draw goes into your own layer that only you can see. Under “Layers” you can add layers, hide them and share them with your section or the whole choir.',
    'annotate.coach3_title': 'Jump links',
    'annotate.coach3_body':
      'Choose “Link” and tap where the jump should start. Then scroll to where the music continues and tap there. Tapping the link later takes you straight to the right place.',
    'annotate.coach_next': 'Next',
    'annotate.coach_skip': 'Skip',
    'annotate.coach_start': 'Start writing',
  },
);
